module.exports = __webpack_public_path__ + "img/swiper-2.e9e95e5.png";